import * as React from "react"
import { CurrentLocale } from "../../lib/IntlTools"
import dwaLogo from '../../../static/images/dwa/dwa-logo.svg';
import "./styles.scss"

export default function Header({ isProductPassportView }) {
    const path = typeof window !== 'undefined' ? window.location.pathname : ''
    const currentLang = CurrentLocale();
    const splitPathName = path?.includes(currentLang) ? path?.split(`/${currentLang}/`)[1] : path?.split('/')[1];

    return <nav className="header">
        {!isProductPassportView && !splitPathName?.includes('dl') ? (
            <div className="logo">
                <a href={`/`}>
                    <img src={dwaLogo} alt="" style={{ mixBlendMode: 'difference' }} />
                </a>
            </div>
        ) : (
            <div className="logo">
                <img src={`/static/images/dwa/dwa-logo.svg`} alt="" />
            </div>
        )}
    </nav>
}
